import { jsx as _jsx } from "react/jsx-runtime";
import { DictationSlotComponent } from '#pplx/frontend/composer-sdk-plugins/dictation/DictationSlotComponent.js';
export function AskDictationSlotComponent(props) {
    // Keep the tight mic spacing off the picker, which also sits next to the primary action.
    return (_jsx("div", { className: "-ml-2 inline-flex empty:hidden", children: _jsx(DictationSlotComponent, { ...props }) }));
}
//# sourceMappingURL=AskDictationSlotComponent.js.map